// Enterでリクエストを送る時等の問題を解決する
export const strictEnter = (parentEvent, event) => {
  // keydownである必要がある
  if (parentEvent.type !== 'keydown') {
    throw new Error('keydownイベントでありません')
  }
  // IME対策(日本語変換時に実行されないように)
  if (parentEvent.isComposing) return
  // 長押しではない(何度も実行されないように) + Enter
  if (parentEvent.repeat || parentEvent.keyCode !== 13) return
  // 実行
  event()
}
